<template lang="pug">
  main.main.main__where-delivery
    header.main__header
      h1.main__title {{ $t('whereDelivery.title') }}
      h2.main__subtitle {{ $t('whereDelivery.subTitle') }}
    .main__container
      .main__content
        form.form.form_where-delivery(@submit.prevent="submitForm")
          .form__row
            .form__label {{ $t('whereDelivery.labels.city') }}
            .form__field
              v-select(:options="optionsCities" label="title" class="custom-select" :value="city" @input="setActiveCity" @search="onSearch" :filterable="false")
                template(slot="option" slot-scope="option" class="option") {{ option.title }}
                template(slot='no-options')
                  div(@mousedown.stop='')
                    | Извините, нет подходящих вариантов
            span.form__error-text(v-if='$v.phrase.$error') {{ $t('whereDelivery.errors.city') }}
          .form__row
            label.form__label {{ $t('whereDelivery.labels.np') }}
            .form__field
              v-select(:options="optionsNp" label="title" :value='np' @input="setActiveNp" class="custom-select")
                template(slot="option" slot-scope="option" class="custom-select__option") {{ option.title }}
                template(slot='no-options')
                  div(@mousedown.stop='')
                    | Извините, нет подходящих вариантов
          .form__row.form__row-fio
            .form__label {{ $t('whereDelivery.labels.fio') }}
            input.form__input(type="text" v-model="$v.fio.$model")
          footer.form__footer
            a.link-back(@click="$router.go(-1)") {{ $t('whereDelivery.buttons.back') }}
            input.button.form__submit(
              type="submit"
              :value="$t('whereDelivery.buttons.continue')"
              :disabled="isDisabled"
            )
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import { required, minLength } from 'vuelidate/lib/validators'
import _ from 'lodash'
import { api } from '@/store/http-common'

Vue.component('v-select', vSelect)

export default {
  name: 'Request_WhereDelivery',
  data () {
    return {
      optionsNp: [],
      optionsCities: [],
      phrase: ''
    }
  },
  validations: {
    np: {
      title: {
        required,
        minLength: minLength(2)
      }
    },
    city: {
      title: {
        required,
        minLength: minLength(2)
      }
    },
    fio: {
      required
    },
    phrase: {
      required,
      minLength: minLength(2)
    },
    validationGroup: ['np', 'city', 'fio']
  },
  methods: {
    onSearch  (search, loading) {
      this.phrase = search
      this.$v.phrase.$touch()
      if (!this.$v.phrase.$invalid) {
        loading(true)
        this.search(loading, this)
      }
    },
    search: _.debounce((loading, vm) => {
      let data = new FormData()
      data.append('phrase', vm.$v.phrase.$model)

      api
        .post('ajax.php?action=sg:service.api.address.findNpCity', data)
        .then(response => {
          vm.optionsCities = response.data.data
          loading(false)
        })
    }, 500),
    setActiveCity (city) {
      this.$store.commit('updateDeliveryCity', city)
      let data = new FormData()
      data.append('city', city.code)
      api
        .post('ajax.php?action=sg:service.api.address.getNpWarenhouses', data)
        .then(response => {
          this.optionsNp = response.data.data
          this.np = this.optionsNp[0]
        })
    },
    setActiveNp (value) {
      if (value) {
        this.np = value
        this.$v.np.$touch()
        this.$store.commit('updateDeliveryWarenhouse', value)
      }
    },
    submitForm () {
      this.complete = true
      this.$router.push({path: '/requestContact'})
    }
  },
  computed: {
    city: {
      get () {
        return this.$store.getters.getDeliveryCity
      },
      set (value) {
        this.$store.commit('updateDeliveryCity', value)
      }
    },
    np: {
      get () {
        return this.$store.getters.getDeliverWarenHouse
      },
      set (value) {
        this.$store.commit('updateDeliveryWarenhouse', value)
      }
    },
    fio: {
      get () {
        return this.$store.getters.getDeliveryReceiverName
      },
      set (value) {
        this.$store.commit('updateDeliveryReceiverName', value)
      }
    },
    complete: {
      get () {
        return this.$store.getters.getDeliveryComplete
      },
      set (value) {
        this.$store.commit('updateDeliveryComplete', value)
      }
    },
    isDisabled () {
      return this.$v.validationGroup.$invalid
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Request_WhereDelivery.vue